module.exports = __webpack_public_path__ + "img/116.63fec0ee.jpg";